import { useTranslation } from 'react-i18next';

const ABOUT_IMG = 'https://readdy.ai/api/search-image?query=professional%20medical%20team%20fertility%20clinic%20doctors%20and%20nurses%2C%20group%20photo%20in%20modern%20hospital%2C%20warm%20professional%20atmosphere%2C%20blue%20and%20white%20medical%20uniforms%2C%20champagne%20gold%20accents%2C%20trustworthy%20expert%20team%2C%20high-end%20medical%20facility%20interior&width=700&height=500&seq=whyus-001&orientation=landscape';

export default function WhyUsSection() {
  const { t } = useTranslation();

  const reasons = [
    { icon: 'ri-shield-check-line', titleKey: 'whyus_legal', descKey: 'whyus_legal_desc' },
    { icon: 'ri-heart-pulse-line', titleKey: 'whyus_medical', descKey: 'whyus_medical_desc' },
    { icon: 'ri-global-line', titleKey: 'whyus_global', descKey: 'whyus_global_desc' },
    { icon: 'ri-file-text-line', titleKey: 'whyus_transparent', descKey: 'whyus_transparent_desc' },
    { icon: 'ri-user-heart-line', titleKey: 'whyus_consultant', descKey: 'whyus_consultant_desc' },
    { icon: 'ri-award-line', titleKey: 'whyus_experience', descKey: 'whyus_experience_desc' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left image */}
          <div className="relative">
            <div className="w-full h-80 md:h-[440px] rounded-2xl overflow-hidden">
              <img src={ABOUT_IMG} alt={t('whyus_title')} className="w-full h-full object-cover object-top" />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-5 -right-5 bg-white rounded-xl p-5 shadow-sm border border-gray-100 max-w-[180px]">
              <div className="text-3xl font-bold text-[#1a3a5c] mb-1">500+</div>
              <div className="text-gray-500 text-xs">{t('whyus_floating_label')}</div>
            </div>
          </div>

          {/* Right content */}
          <div>
            <div className="text-[#c9a96e] text-sm font-medium tracking-widest uppercase mb-2">{t('whyus_label')}</div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a3a5c] mb-4">{t('whyus_title')}</h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              {t('about_desc1')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {reasons.map((r) => (
                <div key={r.titleKey} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center shrink-0 rounded-xl bg-[#1a3a5c]/8 text-[#c9a96e]">
                    <i className={`${r.icon} text-lg`}></i>
                  </div>
                  <div>
                    <div className="font-semibold text-[#1a3a5c] text-sm mb-0.5">{t(r.titleKey)}</div>
                    <div className="text-gray-500 text-xs leading-relaxed">{t(r.descKey)}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}